import type { TState } from './models';

export const selectAppData = (state: TState) => state.application;
export const selectFinishData = (state: TState) => state.finish;
export const selectDeliveryData = (state: TState) => state.delivery;
export const selectDraftData = (state: TState) => state.draft;
export const selectFirstStepData = (state: TState) => state.firstStep;
export const selectSmsData = (state: TState) => state.sms;
export const selectBasketData = (state: TState) => state.basket;
